export default __webpack_public_path__ + "static/media/signIn_signUp_bg_afric.f86e9835.jpg";